import {AnimationClip, AnimationData} from '@wonderlandengine/tweenjs';
import IslandSharkSwimData from './IslandSharkSwim.json';

export class IslandSharkSwim extends AnimationClip {
    static TypeName = 'anim:IslandSharkSwim';
    static InheritProperties = true;

    public data: AnimationData = IslandSharkSwimData;
    public clipName: string = 'IslandSharkSwim';
}
